'use client';

import {getCurrentLanguage} from '@utils/translate.utils';

const VALID_ROUTES = {
  HOME: '/new-home',
  UNITS: '/new-home/units',
};

export function getAppRoute(
  route: keyof typeof VALID_ROUTES,
  routeTrail?: string
) {
  return `${getCurrentLanguage()}${VALID_ROUTES[route]}${routeTrail ?? ''}`;
}

export function pushToQueryParams(queryString: string) {
  window.history.replaceState(null, '', `?${queryString}`);
}
